module.exports = "<app-img-header imgUrl=\"/assets/images/img-headers/resort.jpg\"></app-img-header>\n\n<div class=\"background-params\">\n  <div class=\"container\">\n    <p class=\"text\" translate [innerHTML]=\"'RESORT.TEXT' | translate\"></p>\n  </div>\n\n  <app-quote translate [quote]=\"'RESORT.QUOTE' | translate\" author=\"- Ivo Andrić\"></app-quote>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/resort/resort.component.html
// module id = 788
// module chunks = 1